import script from "./stdOnboardingFifthPage.vue?vue&type=script&setup=true&lang=js"
export * from "./stdOnboardingFifthPage.vue?vue&type=script&setup=true&lang=js"

import "./stdOnboardingFifthPage.vue?vue&type=style&index=0&id=0e412c60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e412c60"]])

export default __exports__